import React, { useReducer, useState, useEffect} from 'react';
import CustomerOrderItem from './CustomerOrderItem';
import AutoSuggestInput from '../../shared/components/formElements/AutoSuggestInput';

// import Input from '../../shared/components/formElements/Input';
// import {
//     VALIDATOR_MINLENGTH,
//     VALIDATOR_MAXLENGTH,
//     VALIDATOR_NUMERIC
//   } from '../../shared/util/validators';
import './CustomerOrderList.css';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
export const ACTIONS = {
    ADD_CUSTOMER_ITEM: "add-customerItem",
    DELETE_CUSTOMER_ITEM: 'delete-customerItem'
}

export const ERRORS = {
    CUSTOMER_NOT_FOUND: "Please add a full name. For a new customer also add phone number.",
    ITEM_NOT_FOUND: "The item does not exist. Add the item and try again.",
    ITEM_ALREADY_EXIST: "The item has already added to the order."
}

const reducer = (customerItem, action) => {
switch (action.type) {
    case ACTIONS.ADD_CUSTOMER_ITEM:
        if (newCustomerItem(action.payload.newCustomer)) {
            action.payload.disabled(true);
            return [...customerItem, newCustomerItem(action.payload.newCustomer)]
        } else {
            action.payload.setError(ERRORS.CUSTOMER_NOT_FOUND);;
            action.payload.disabled(false);
            return [...customerItem]
        }

    case ACTIONS.DELETE_CUSTOMER_ITEM:
        return customerItem.filter(customer => customer.id !== action.payload.id)
    default:
        return customerItem
}
}

  const newCustomerItem = (newCustomer, setError) => { 
    if (newCustomer.length > 0) {
        return { 
            id: newCustomer[0].id, 
            phone: newCustomer[0].phone,
            name: newCustomer[0].name,
            lastname: newCustomer[0].lastname,
        }
    }
    return false;
  }

  const CustomerOrderList = ({suggestionArray, id, onInput, type, label}) => {
    const [orderCustomer, dispatch] = useReducer(reducer, [])
    const [customerName, setCustomerName] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [inputDisabled, setinputDisabled] = useState(false);
    const [msg, setMsg] = useState();

    const handleSubmit = (event) => {
        event.preventDefault();
        let newCustomer = suggestionArray.filter(customer => {
            return (
                customer.name.toLowerCase() + " " + customer.lastname.toLowerCase() ===
                customerName.toLowerCase() 
            )
        })

        if (newCustomer.length === 0 && 
            customerName && newPhone && 
            customerName.split(" ")[1] &&
            newPhone.length === 10            
        ) {
            if(customerName.split(" ")[1])

            newCustomer = [{
                name: customerName.split(" ")[0],
                lastname: customerName.split(" ")[1],
                id: "new",
                phone: newPhone
            }]
            
        }
        
        dispatch({
             type: ACTIONS.ADD_CUSTOMER_ITEM, 
             payload: {
                newCustomer: newCustomer,
                disabled: setinputDisabled,
                setError: setMsg,
            }
        });
        setCustomerName('');
        setNewPhone("");
    }

    const suggestion = suggestionArray.map(customer => {
        return(
          {
            name: customer.name + " " + customer.lastname,
            customerId: customer.id,
          }
        )
      })

    const onChange = (event, { newValue }) => {
        setCustomerName(newValue);       
    };

    useEffect(() => {
        onInput(id, orderCustomer, orderCustomer.length !== 0)
    }, [id, orderCustomer, onInput]);

    const newPhoneHandler = (event) => {
        setNewPhone(event.target.value)
    }

    const foundCustomer = suggestion.find(customer => customer.name === customerName)

    return (
        <>
            {msg && <ErrorModal error={msg} onClear={() => setMsg(null)} />}
            <div className="customer-container">
                <div className="customer-input">
                <label htmlFor="name" className="f6 b db mb2">Name </label>
                    <AutoSuggestInput
                        type={type}
                        placeholder="Add a customer"
                        onChange={onChange}
                        suggestionArray= {suggestion}
                        inputValue={customerName}
                        disabled = { inputDisabled ? "disabled" : ""} 
                    />                 
                </div>
                { !foundCustomer && <div className="b">
                <label htmlFor="name" className="ml2 mb3 f6 b db mb2">Phone </label>
                    <input style={{height:"35px", marginBottom:"20px", backgroundColor:"#f8f8f8", border:"1px-solid-#510077", }}
                     className="input-customer-phone ba b--black-10 pa2 mb2 db w-80 ml2 "                
                        id="newPhone"
                        type="number"
                        placeholder="Add a phone#"
                        onChange={newPhoneHandler}
                        value={newPhone} 
                    />
                </div>}
                <div className="customer-add">
                    <button className={`${
                        foundCustomer ? "add-button-glow": customerName.length > 0 &&
                         String(newPhone).length > 0 ?  "add-button-glow" : ""} add-button`}
                          style={{marginLeft:"15px"}} onClick={handleSubmit} disabled={inputDisabled}
                          >ADD</button>
                </div>
                <div className="customer-display">
                    
                    <table className="customer-table">
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Last Name</th>
                                <th>Phone</th>
                                <th>Cancel</th>
            
                            </tr >
                            {
                            orderCustomer.map((Customer) => {
                                return <CustomerOrderItem 
                                    key={Customer.id} 
                                    orderCustomer={Customer} 
                                    dispatch={dispatch}
                                    disabled={setinputDisabled}                  
                                />}    
                            )
                            }
                        </tbody>
                    </table>
                </div>             
            </div>
        </>
    )
  }

  export default CustomerOrderList;